import { useCallback, useState } from 'react';

// to store a fn in state, we need to wrap it in a fn
// https://stackoverflow.com/a/55621325/9117995

export function useFunctionState<T = VoidFunction>(
  initialValue?: T,
): [T | undefined, (fn: T) => void] {
  const [fn, setState] = useState<T | undefined>(() => initialValue);

  const setFunction = useCallback((updatedFn: T) => setState(() => updatedFn), []);

  return [fn, setFunction];
}
